import React, { useContext, useEffect, useState } from 'react'

import queryString from 'query-string'
import { RouteComponentProps, withRouter } from 'react-router'
import { Button, Form, Header } from 'semantic-ui-react'

import Data from '../../api/Data'
import { GlobalContext } from '../../contexts/GlobalContext'
import { UserContext } from '../../contexts/UserContext'
import Moment from '../../utils/Moment'

import ExternalLink from '../../components/common/ExternalLink'
import StripePricingTableComponent from './MyAccountDetailsStripePricing'
import MyAccountPaymentSuccessModal from './MyAccountPaymentSuccessModal'

const MyAccountDetails = (props: IProps) => {
  const { isMobile } = useContext(GlobalContext)
  const { userProfile } = useContext(UserContext)

  const { location, teamId } = props

  const [showSubSuccessModal, setShowSubSuccessModal] = useState<boolean>(false)

  useEffect(() => {
    const { success } = queryString.parse(location.search)

    if (success) setShowSubSuccessModal(true)
  }, [location.search])

  const submitManageBillingForm = async () => {
    const { data, error } = await Data.createStripeCustomerPortalSession()

    if (error) alert('Oops something went wrong')

    window.location.href = data!.url
  }

  const { subscriptionExpiryDate, plan: currentPlan, hasActiveSubscription } = userProfile

  const expirationDateFormatted = subscriptionExpiryDate ? Moment(subscriptionExpiryDate).format('ll') : 'None'

  console.log('Rendering Account Details Page')

  return (
    <>
      <Header as="h3">Current Plan</Header>

      {hasActiveSubscription ? (
        <Form>
          <Form.Field>
            <p>{currentPlan.title}</p>
          </Form.Field>

          <Button primary fluid={isMobile} onClick={submitManageBillingForm}>
            Manage My Billing
          </Button>
        </Form>
      ) : (
        <>
          <p>My current plan: {currentPlan.title}</p>
          <p>Expiration date: {expirationDateFormatted}</p>

          <StripePricingTableComponent clientReferenceId={teamId} />
        </>
      )}
      
      {showSubSuccessModal && (
        <MyAccountPaymentSuccessModal setShowModal={setShowSubSuccessModal}></MyAccountPaymentSuccessModal>
      )}

      <br />
      
      <ExternalLink url="https://billing.vloggi.com/p/login/4gw4gwbrn3Qa1jObII">Manage Account</ExternalLink>
    </>
  )
}

interface IProps extends RouteComponentProps<any> {
  teamId: number
}

export default withRouter(MyAccountDetails)
